import { connect } from 'react-redux';
import { selectActiveVenue, selectVenueSmartspotEnabled } from 'selectors/general';
import VenueSmartSpotStatus from './VenueSmartSpotStatus';

const mapStateToProps = (state, ownProps) => {
  const { isSmartspotEligible } = selectActiveVenue(state, ownProps);

  return {
    ...ownProps,
    isSmartspotEligible,
    smartspotEnabled: selectVenueSmartspotEnabled(state, ownProps),
  };
};

export default connect(mapStateToProps)(VenueSmartSpotStatus);
